import { render, staticRenderFns } from "./TeamLinks.vue?vue&type=template&id=6909ae52&scoped=true&"
import script from "./TeamLinks.vue?vue&type=script&lang=js&"
export * from "./TeamLinks.vue?vue&type=script&lang=js&"
import style0 from "./TeamLinks.vue?vue&type=style&index=0&id=6909ae52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6909ae52",
  null
  
)

export default component.exports